<template>
  <div class="tab-sticky" :class="{ show: show }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabSticky",
  props: {
    active: { type: String, default: "" },
    show: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.tab-sticky {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: -222px;
  z-index: 9999;
  background-color: $white;
  transition: bottom 300ms ease;
  &.show {
    bottom: 0;
  }
}
</style>
